module.exports = __webpack_public_path__ + "fepro/img/cards-box.3e8b73eb.png";